import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "fileInput"]
  static values = { url: String }

  connect() {
    // Create hidden file input
    this.fileInput = document.createElement("input")
    this.fileInput.type = "file"
    this.fileInput.className = "hidden"
    this.handleFileSelectBound = this.handleFileSelect.bind(this)
    this.fileInput.addEventListener("change", this.handleFileSelectBound)
    this.element.appendChild(this.fileInput)
  }

  disconnect() {
    // Clean up file input when controller is disconnected
    if (this.fileInput) {
      this.fileInput.removeEventListener("change", this.handleFileSelectBound)
      this.fileInput.remove()
      this.fileInput = null
    }
  }

  selectFile(event) {
    event.preventDefault()
    this.fileInput.click()
  }

  async handleFileSelect(event) {
    const file = event.target.files[0]
    if (!file) return

    // Show loading state
    this.setLoading(true)

    const formData = new FormData()
    formData.append("file", file)

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": this.getCSRFToken(),
          "Accept": "text/vnd.turbo-stream.html, application/json"
        }
      })

      if (response.ok) {
        const contentType = response.headers.get("Content-Type") || ""

        if (contentType.includes("turbo-stream")) {
          // Handle Turbo Stream response - this will update the task details in place
          const html = await response.text()
          Turbo.renderStreamMessage(html)
          this.setLoading(false)
        } else {
          // Fallback: refresh the task_details turbo frame if we're in a modal
          const modal = this.element.closest("dialog")
          if (modal) {
            // We're in a modal - refresh the task frame within the modal
            const taskFrame = modal.querySelector("turbo-frame") || document.querySelector("turbo-frame#task_details")
            if (taskFrame) {
              taskFrame.reload()
              this.setLoading(false)
            } else {
              window.location.reload()
            }
          } else {
            // Not in a modal, safe to reload
            window.location.reload()
          }
        }
      } else {
        const data = await response.json()
        alert(data.error || "Upload failed")
        this.setLoading(false)
      }
    } catch (error) {
      alert("Upload failed: " + error.message)
      this.setLoading(false)
    }

    // Clear the file input
    this.fileInput.value = ""
  }

  setLoading(loading) {
    const button = this.buttonTarget
    if (loading) {
      button.disabled = true
      button.dataset.originalHtml = button.innerHTML
      button.innerHTML = '<span class="loading loading-spinner loading-xs"></span>'
    } else {
      button.disabled = false
      button.innerHTML = button.dataset.originalHtml
    }
  }

  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
